export default __webpack_public_path__ + "static/media/4.18a11506.pdf";